<template>
  <Spinner v-if="loading" />
  <main class="home" v-else>
    <HeaderM3
      :logoLinkRoute="LinkToHome"
      :showSuspiciousActivityButton="showSuspiciousSaleFlag"
      :showChat="showChatBot"
    />
    <div class="main-body d-flex flex-row">
      <div class="w-100">
        <NavigationBar />
        <SaleTimeOut />

        <div class="container p-0">
          <Policy />
        </div>
      </div>
      <InConsoleSidebar v-if="showInconsoleSidebar" />
    </div>

    <HelpMessage />
  </main>
</template>

<script setup lang="ts">
import { ref, computed, getCurrentInstance, onMounted, watch } from "vue";
import { useI18n } from "@/apps/merchant3/composables/useI18n";
import { useStore } from "vuex";
import { useRoute } from "vue-router";

import HeaderM3 from "@/apps/merchant3/components/HeaderM3.vue";
import SaleTimeOut from "@/apps/merchant3/shared-components/common/SaleTimeout.vue";
import NavigationBar from "@/apps/merchant3/shared-components/common/NavigationBar.vue";
import Policy from "@/apps/merchant3/components/steps/policy/Policy.vue";
import HelpMessage from "@/apps/merchant3/components/HelpMessage.vue";
import Spinner from "@/apps/merchant3/shared-components/ui/Spinner.vue";
import InConsoleSidebar from "@/apps/merchant3/components/in-console/ui/InConsoleSidebar.vue";

import {
  productVersionRecordingAppsMapper,
  recorder,
} from "@/apps/merchant3/shared-services/recording.service";
import useCartPersistState from "@/apps/merchant3/hooks/useCartPersistState";
import { RouteName } from "@/apps/merchant3/router/RouteName";
import { RoutesPageSteps } from "@/apps/merchant3/router/RoutesPageSteps";
import { CheckoutStep } from "@/apps/merchant3/enums/checkoutStepEnum";
import useConfigurations from "@/apps/merchant3/hooks/useConfigurations";
import { usePageTitle } from "@/apps/merchant3/hooks/usePageTitle";

const route = useRoute();
const store = useStore();
const { t } = useI18n();
const { globalComponents, isConfigLoaded, loadConfigs } = useConfigurations();
const showSuspiciousSaleFlag = computed(() => {
  return globalComponents.value?.showSuspiciousSaleFlag ?? false;
});
const showInconsoleSidebar = computed(
  () =>
    globalComponents.value?.showInConsoleMessages ||
    globalComponents.value?.showInConsoleTraining ||
    false
);
const showChatBot = computed(
  () => globalComponents.value?.showChatBot ?? false
);

const currentStep = route.meta.step as CheckoutStep;
const LinkToHome = ref(RouteName.M3Welcome);
const app = getCurrentInstance()?.appContext.app;
usePageTitle("PayJoy - " + t("PAGE_TITLE_PRIVACY_POLICY"));

const loading = ref(true);

const cartTag = computed(() => store.state.carts.cartTag);

const updateRecorder = () => {
  recorder(app)?.updateRecordingInfo(store.state.carts.userId, {
    cartTag: store.state.carts.cartTag,
    merchantId: store.state.carts.merchantId,
    clerkId: store.state.carts.salesClerkId,
    productVersion: store.state.carts.productVersion,
    country: store.state.merchant?.merchant?.country,
  });
};

watch(
  [cartTag, isConfigLoaded],
  () => {
    if (cartTag.value && isConfigLoaded.value) {
      loading.value = false;
    }
  },
  { immediate: true }
);

onMounted(async () => {
  useCartPersistState(() => {
    loadConfigs(cartTag.value, currentStep);
    store.dispatch("carts/setStep", RoutesPageSteps.PrivacyPolicy);
    const recordingApp = productVersionRecordingAppsMapper(
      store.state.carts.productVersion
    );
    recorder(app)?.startRecording(recordingApp);
    updateRecorder();
    return true;
  });
});
</script>
<style scoped lang="scss"></style>
